import * as z from "zod";
import {
  grantCustomRoleResolve,
  grantPrincipalResolve,
} from "../rbac/grantResources";
import { SHAREABLE_SCOPE_KINDS } from "../rbac/permissions";
import { SCOPE_MANAGE_GRANTS_PERMISSION } from "../rbac/roles";
import { applyScopeRoleGrants } from "../rbac/applyScopeRoleGrants";
import { grantEntry } from "../rbac/validation";
import { mutator } from "./mutator";

export const setScopeRoleGrants = mutator({
  schema: z.object({
    scopeId: z.string(),
    scopeKind: z.enum(SHAREABLE_SCOPE_KINDS),
    grants: z.array(grantEntry),
  }),
  resolve: {
    ...grantPrincipalResolve,
    ...grantCustomRoleResolve,
  },
  permissions: [
    {
      permission: ({ args }) => SCOPE_MANAGE_GRANTS_PERMISSION[args.scopeKind],
      scopeId: ({ args }) => args.scopeId as string,
    },
  ],
  fn: async ({
    tx,
    ctx,
    args: { scopeId, scopeKind, grants, grantCustomRoles },
  }) => {
    await applyScopeRoleGrants({
      tx,
      ctx,
      scopeId,
      scopeKind,
      grants,
      customRoles: grantCustomRoles,
    });
  },
});
